import React, { memo, useContext, useState } from "react";
import { Typing } from "../atoms";
import { BotContext } from "../context";
import { AnswerBubble } from "../pages/bot/history";

// use for answer of live chat
const AnswerComponent = memo(() => {
  const { lastLVA } = useContext(BotContext);
  const [answer] = useState(lastLVA);

  return (
    <>
      {!answer ? (
        <Typing />
      ) : (
        answer.map((answer) => (
          <AnswerBubble
            key={answer.id}
            message={{
              text: answer.answer,
              status: true,
              question_date: answer.answer_time,
            }}
            chat_agent={"OPT"}
          ></AnswerBubble>
        ))
      )}
    </>
  );
});

export { AnswerComponent };
